// DS: i4.16
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Notification: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="M15 19a2 2 0 01-2 2h-2a2 2 0 01-2-2h6zM13 2a1 1 0 011 1v1h2.656c.429 0 .835.41.907.917L19 13l1.707 1.707a1 1 0 01.293.707V17a1 1 0 01-1 1H4a1 1 0 01-1-1v-1.586a1 1 0 01.293-.707L5 13l1.437-8.083C6.51 4.41 6.915 4 7.344 4H10V3a1 1 0 011-1h2z"
      />
    </svg>
  </IconWrap>
);
Notification.displayName = 'Notification';

export default Notification;
